import BolusApi from "../../../api/bolus-api";

// initial state
const initialState = () => ({
  isFetching: false,
  boluses: [],
  data: []
});

// actions
const actions = {
  listBoluses: async ({ commit }, payload) => {
    const { available_only, with_bolus_ph, bolus_exception} = payload || {};
    try {
      commit("request");
      const apiResponse = await BolusApi.list({availableOnly: available_only, withBolusPh:with_bolus_ph, bolusException: bolus_exception});
      if (apiResponse && apiResponse.data) {
        commit("listBolusesSuccess", apiResponse.data);
      } else {
        commit("listBolusesFailed", apiResponse);
      }
    } catch (e) {
      commit("listBolusesFailed", e);
    }
  },
  getBoluses: async ({ commit }, payload) => {
    const { available, bolus_id, withSensorLog } = payload || {};
    try {
      commit("request");
      const apiResponse = await BolusApi.list({ available: available, bolusID: bolus_id, withSensorLog: withSensorLog });
      if (apiResponse && apiResponse.data) {
        commit("getBolusesSuccess", apiResponse.data);
      } else {
        commit("getBolusesFailed", apiResponse);
      }
    } catch (e) {
      commit("getBolusesFailed", e);
    }
  },

  clear: ({ commit }) => {
    commit("clear", initialState());
  }
};

// mutations
const mutations = {
  request: state => {
    state.isFetching = true;
  },
  getBolusesSuccess: (state, payload) => {
    state.isFetching = false;
    state.data = payload;
  },
  getBolusesFailed: state => {
    state.isFetching = false;
  },
  listBolusesSuccess: (state, payload) => {
    state.isFetching = false;
    state.boluses = payload;
  },
  listBolusesFailed: state => {
    state.isFetching = false;
  },
  clear: (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/boluses.js